import { Field } from 'redux-form';

import { RadioButton } from 'common/components/forms';

import PickupLocation from './PickupLocation';

const PickupLocations = (props) => {
  const { carrierPickupLocation, settings } = props;

  if (
    (!carrierPickupLocation.data && !carrierPickupLocation.isFetching) ||
    !carrierPickupLocation.query
  ) {
    return (
      <div className="c7-checkout__content__radio-options-group">
        <div>
          Loading {settings.data.shipCompliant.carrierForPickupLocations} and
          retail locations near you.
        </div>
        <div>
          <label className="c7-radio" htmlFor="shipTo">
            <Field
              name="carrierPickupLocationId"
              component={RadioButton}
              label="shipTo"
              type="radio"
              value="shipTo"
              noLabel
            />
            <div>
              <strong>Ship to Shipping Address</strong>
            </div>
          </label>
        </div>
      </div>
    );
  }
  const carrierPickupLocationArray = locationArray(carrierPickupLocation.query);

  if (carrierPickupLocationArray.length === 0) {
    return (
      <div className="c7-checkout__content__radio-options-group">
        <div>
          Unfortunately there are no{' '}
          {settings.data.shipCompliant.carrierForPickupLocations} or retail
          locations near you.
        </div>
        <div>
          <label
            className="c7-radio"
            htmlFor="radiocarrierPickupLocationId-shipTo"
          >
            <Field
              name="carrierPickupLocationId"
              component={RadioButton}
              label="shipTo"
              type="radio"
              value="shipTo"
              noLabel
            />
            <div>
              <strong>Ship to Shipping Address</strong>
            </div>
          </label>
        </div>
      </div>
    );
  }

  return (
    <div className="c7-checkout__content__radio-options-group">
      {carrierPickupLocationArray.map((carrierPickupLocationId) => (
        <PickupLocation
          key={carrierPickupLocationId}
          carrierPickupLocation={
            carrierPickupLocation.data[carrierPickupLocationId]
          }
          settings={settings}
        />
      ))}
      <div>
        <label className="c7-radio" htmlFor="shipTo">
          <Field
            name="carrierPickupLocationId"
            component={RadioButton}
            label="shipTo"
            type="radio"
            value="shipTo"
            noLabel
          />
          <div>
            <strong>Ship to Shipping Address</strong>
          </div>
        </label>
      </div>
    </div>
  );
};

const locationArray = (array) => {
  if (array.length < 4) {
    return array;
  }
  const newArray = array.slice(0, 3);
  return newArray;
};

export default PickupLocations;
